module.exports = __webpack_public_path__ + "static/media/KW12_a.dc33e8ee.png";